export default "/images/silver-app.png?5944c5df9440e72c20e026a381443a39";